import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImageComponent extends InputComponent {
    clear = output<void>();

    protected getValidators(): any[] {
        const validators = super.getValidators();
        const meta = this.meta();

        if (meta) {
            if (meta.pattern) {
                validators.push(Validators.pattern(meta.pattern));
            }
        }
        return validators;
    }

    public onClear() {
        this.formControl()?.setValue('')
        this.clear.emit();
    }
}
